"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const application_provider_1 = require("../../game/pixi/application.provider");
const room_provider_1 = require("../../game/room/room.provider");
const Matrix_1 = require("../../engine/lib/util/Matrix");
const loader_1 = require("../../engine/loader");
const game_1 = require("../../game");
let GameView = class GameView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.app = game_1.gameRef.get(application_provider_1.ApplicationProvider);
        this.game = game_1.gameRef;
        this.room = game_1.gameRef.get(room_provider_1.RoomProvider);
        this.loader = game_1.gameRef.get(loader_1.Loader);
        this.isLoaded = false;
        this.isMounted = false;
    }
    activated() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isMounted) {
                this.app.createApp({ view: this.$el });
                this.isMounted = true;
                if (!this.isLoaded)
                    return this.$router.replace('/splash');
                return;
            }
            this.startGame();
        });
    }
    startGame() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.room.create({
                roomUserDictionary: {
                    abc: {
                        id: '1',
                        name: 'user_1',
                        look: 'hd-180-1.hr-110-61.ch-210-66.lg-280-110.sh-305-62',
                        action: 'mv,respect',
                        direction: 2,
                        head_direction: 2,
                        x: 64,
                        y: 32,
                        z: 8
                    },
                },
                heightmap: Matrix_1.Matrix.fromLegacyString(`
        000000000
        000000000
        000000000
        000000000
        000000000
        000000000
        000000000
        000000000
      `),
            });
        });
    }
};
__decorate([
    vue_property_decorator_1.Provide(),
    __metadata("design:type", application_provider_1.ApplicationProvider)
], GameView.prototype, "app", void 0);
__decorate([
    vue_property_decorator_1.Provide(),
    __metadata("design:type", Object)
], GameView.prototype, "game", void 0);
__decorate([
    vue_property_decorator_1.Provide(),
    __metadata("design:type", room_provider_1.RoomProvider)
], GameView.prototype, "room", void 0);
__decorate([
    vue_property_decorator_1.Provide(),
    __metadata("design:type", loader_1.Loader)
], GameView.prototype, "loader", void 0);
GameView = __decorate([
    vue_property_decorator_1.Component({
        name: 'GameView'
    })
], GameView);
exports.default = GameView;
